/*
 * Airgo Booking navigation
 * Uses the HTML5 pushState + jQuery ajax functionality
 */
import get_data from './booking-map.js';
// import intlTelInput from 'intl-tel-input';
import * as intlTelInput from 'intl-tel-input';
import utilsScript from 'intl-tel-input/build/js/utils';

var type = $( '.main-section' ).attr( 'data-type' );
var step = $( '.main-section' ).attr( 'data-current' );
var cardElementTemplate = null;

var Cart = {
  transactions: {
    purchase_units: [{
      amount: {
        value: '0',
        total: '0'
      }
    }]
  },
  items: [],
  total: 0,
  deposit: 0
};

if (typeof current_session_data !== 'undefined') {
  // Existe SESSION
  if (type && step) {
    // Existe Type y step
    if (step > 1) {
      step = 1;
      window.history.pushState({step: step}, siteData.bookingUrls[type][step].title, siteData.bookingUrls[type][step].permalink);
      booking_load_step_data({step: step});
    }
    if (current_session_data.inventory && current_session_data.inventory.type === type) {
      let this_step = current_session_data.inventory;

      let nextStep = parseInt(this_step.step);
      let type = this_step.type;
      let url  = siteData.bookingUrls[type][nextStep].permalink;

      if (this_step.html && this_step.html.form) {
        $('#bookingStep2').html(this_step.html.form);
      }

      step = nextStep;
      window.history.pushState(this_step, siteData.bookingUrls[type][nextStep].title, url);
      booking_load_step_data(this_step);
    }
    if (current_session_data.contact && current_session_data.contact.type === type) {
      let this_step = current_session_data.contact;

      let nextStep = parseInt(this_step.step);
      let type = this_step.type;
      let url  = siteData.bookingUrls[type][nextStep].permalink;

      step = nextStep;
      window.history.pushState(this_step, siteData.bookingUrls[type][nextStep].title, url);
      booking_load_step_data(this_step);
    }
  }
} else {
  // If there's no session data, return to step 1
  if (type && step) {
    if (step > 1) {
      step = 1;
      window.history.pushState({step: step}, siteData.bookingUrls[type][step].title, siteData.bookingUrls[type][step].permalink);
      booking_load_step_data({step: step});
    }
  }
}

$('#bookingStep1').submit(function(e){
  e.preventDefault();
  toggleModal('loader');
  //loading
  var tempButtonText = $('#bookingStep1Submit').val();
  $('#bookingStep1Submit').prop('disabled',true);
  $('#bookingStep1Submit').val( siteData.lang[0] );
  var form = $(this);
  var nextStep = parseInt(step) + 1;
  var url  = siteData.bookingUrls[type][nextStep].permalink;

  let children = form.find('[name^=children]').first();
  if (!children.val() || children.val() === "") {
    children.val(0);
  }

  get_data({
    object : 'inventory',
    params : {
      form: form.serialize(),
      type: type,
      step: parseInt(step)
    }
  },function(items){
    if(items){
      if(items.errors){
        toggleModal('loader');
        if(items.errors.hasOwnProperty('empty')){
          items.errors.empty.forEach( function(field){
            document.querySelector(`input[name='${field}']`).style.border = '1px solid red';
            document.querySelector(`input[data-name='${field}']`).style.border = '1px solid red';
          });
        }
        if(items.errors.hasOwnProperty('missing')){
          items.errors.missing.forEach( function(field){
            document.querySelector(`input[name='${field}']`).style.border = '1px solid red';
            document.querySelector(`input[data-name='${field}']`).style.border = '1px solid red';
          });
        }
        if(items.errors.hasOwnProperty('invalid')){
          items.errors.invalid.forEach( function(field){
            document.querySelector(`input[name='${field}']`).style.border = '1px solid red';
            document.querySelector(`input[data-name='${field}']`).style.border = '1px solid red';
          });
        }
        $('#bookingStep1Submit').prop('disabled',false);
        $('#bookingStep1Submit').val( tempButtonText );
      }else{
        let totalItems = Object.keys(items.items[0]).length;
        if (window.matchMedia('(max-width: 767px)').matches){
          $('#map').addClass('active-mobile');
          $('#map').find('.button-map-wrapper').hide();
        }
        if(type=='airport-pickup'){
          //show variations list
          document.querySelector('[data-section-title]').textContent = totalItems + ' ' + siteData.lang[10];
          document.querySelector(`[data-step="1"] [data-view="airport-pickup-list"]`).style.display = 'block';
          showItemsVariations(items)
          
          let slipElements = document.querySelectorAll(`[data-slip]`);
          slipElements.forEach(function(element){
            element.addEventListener('click', function(){
              toggleModal('loader');
              toggleSubmitText('#bookingStep1Submit');
              let slip = element.getAttribute('data-slip');

              get_data({
                object : 'slip',
                params : {
                  form: form.serialize(),
                  type: type,
                  step: parseInt(step),
                  slip: slip,
                  way: 'arrival'
                }
              },function(items){
                if(items.html){
                  
                  $('#mapRender').removeClass('mapPreview');
                  //This is where we update the address bar with the 'url' parameter
                  Cart.booking_id = items.pre_booking_code;
                  window.history.pushState(items, siteData.bookingUrls[type][nextStep].title, url);
                  $('#bookingStep2').html(items.html.form);
                  booking_load_step_data(items);
                  toggleModal('loader');
                  toggleSubmitText('#bookingStep1Submit');
                }else{
                  let totalItems = Object.keys(items.items[0]).length;
                  document.querySelector('[data-section-title]').textContent = totalItems + ' ' + siteData.lang[11];
                  showItemsVariations(items);
                  toggleModal('loader');
                  toggleSubmitText('#bookingStep1Submit');
                  
                  let slipElements = document.querySelectorAll(`[data-slip]`);
                  slipElements.forEach(function(element){
                    element.addEventListener('click', function(){
                      toggleModal('loader');
                      toggleSubmitText('#bookingStep1Submit');
                      let slip = element.getAttribute('data-slip');

                      get_data({
                        object : 'add',
                        params : {
                          form: form.serialize(),
                          type: type,
                          step: parseInt(step),
                          slip: slip,
                          way: 'departure'
                        }
                      },function(items){
                        $('#mapRender').removeClass('mapPreview');
                        //This is where we update the address bar with the 'url' parameter
                        Cart.booking_id = items.pre_booking_code;
                        window.history.pushState(items, siteData.bookingUrls[type][nextStep].title, url);
                        $('#bookingStep2').html(items.html.form);
                        booking_load_step_data(items);
                        toggleModal('loader');
                        toggleSubmitText('#bookingStep1Submit');
                      });
                    });
                  });
                }
              });

            },false);
          });
        }else{
          /*
          * Items selection modal should be launched from here
          */
          
          $('#items-list').show();
          $('#mapRender').addClass('mapPreview');
          booking_load_map_items(items);
        }
        toggleModal('loader');
        toggleSubmitText('#bookingStep1Submit');
      }
    }else{
      //alert(error message);
    }
  });
});
$('#bookingStep2').submit(function(e){
  e.preventDefault();
  toggleModal('loader');
  //var pre_booking_code = $( '.main-section' ).attr( 'data-pre-booking' );
  //loading
  var tempButtonText = $('#bookingStep2Submit').val();
  $('#bookingStep2Submit').prop('disabled',true);
  $('#bookingStep2Submit').val( siteData.lang[0] );
  var form = $(this);
  var nextStep = parseInt(step) + 1;
  var url  = siteData.bookingUrls[type][nextStep].permalink;

  get_data({
    object : 'contact',
    params : {
      form: form.serialize(),
      type: type,
      step: parseInt(step)
    }
  },function(items){
    toggleModal('loader');
    window.history.pushState(items, siteData.bookingUrls[type][nextStep].title, url);
    booking_load_step_data(items);
    $('#bookingStep2Submit').prop('disabled',false);
    $('#bookingStep2Submit').val( tempButtonText );
  });
});
/**
 * - Guardar el estado del item en el carrito
 * * - Cada que se añada un item al carrito, poner loading
 * - Validar que todos los items estén completamente cargados
 * * - Si todos los items están cargados finalizar loading
 * * - De lo contrario no hacer nada
 */

/**
 *
 * @param cart Object  { item | items, deposit, total }
 * @param doWait set `true` if want to enable loaders (it uses internal counter)
 * @returns Cart
 */
function updateCart(cart, doWait = false) {
  let receivedCart = cart;

  if ( receivedCart ) {
    // Si viene items en el receivedCart, añadirlos al Cart global
    if (receivedCart.items) {
      // Fix: add all received items instead of validate if exists or not
      Cart.items = receivedCart.items.map(receivedItem => {
        if(receivedItem[0] != undefined) {
          return { ...receivedItem[0], leftRequests: 0 };
        }

        return { ...receivedItem, leftRequests: 0 };
      });
    }

    if (receivedCart.item) {
      let foundIndex = Cart.items.findIndex(item => item.sku === receivedCart.item.sku);

      // Si el item no existe en el carrito, añadirlo
      if (foundIndex < 0) {
        // Si es peticion final poner contador a 0, de lo contrario sumar contador
        receivedCart.item.leftRequests = doWait ? 1 : 0;
        // Añadir al carrito
        Cart.items.push(receivedCart.item);
      } else {
        // Actualizar valores del primer item que se encuentre con ese SKU
        let item = Cart.items[foundIndex];
        if (doWait) {
          item = { ...item, ...receivedCart.item };
          item.leftRequests++;
        } else {
          item.leftRequests--;
        }
        Cart.items[foundIndex] = item;
      }

    }

    // Asignar porcentaje para calcular el deposito
    if (receivedCart.percent) {
      Cart.percent = parseFloat(receivedCart.percent) * 0.01;
    }

  }

  // Calcular totales
  Cart.total = parseFloat(Cart.items.reduce((currentTotal, item) => {
    if ( ( typeof item.opt !== 'undefined' && ( item.opt === "in" || parseInt(item.opt) > 0 ) ) || !item.opt ) {
      return currentTotal + parseFloat(item.rate.total || 0);
    } else {
      return currentTotal;
    }
  }, 0));
  // Calcular deposit
  Cart.deposit = parseFloat(Cart.total) * Cart.percent;

  // Update total amount
  $('#total_due').html(booking_load_price(Cart.total));
  $('#payment_full_amount').html(booking_load_price(Cart.total));
  $('#payment_full_input').val(Cart.total);

  // Update deposit amount
  $('#payment_deposit_amount').html(booking_load_price(Cart.deposit));
  $('#payment_deposit_input').val(Cart.deposit);

  // Habilitar/deshabilitar botones de pago
  if ( receivedCart ) {
    if (doWait) {
      loadingCart();
    } else {
      let leftRequests = Cart.items.reduce((sum, item) => {
        return sum += item.leftRequests
      }, 0);

      // Hide deposit selector if not in Cart
      if (!receivedCart.deposit) {
        $('#payment_deposit_wrapper').addClass('hide');
      } else {
        $('#payment_deposit_wrapper').removeClass('hide');
      }

      if (leftRequests == 0) {
        loadingCart(false);
      }
    }
  }

  Cart.transactions = {
    purchase_units: [{
      amount: {
        value: $('input[name="payment"]:checked').val(),
        total: $('input[name="payment"]:checked').val()
      }
    }]
  };
}

/**
 * Add loading animation to total container and payment buttons
 * @param { boolean } isLoading
 * @returns void
 */
function loadingCart(isLoading = true) {
  if (isLoading) {
    $('.payments-buttons, [data-payment-total]').addClass('loading');
  } else {
    $('.payments-buttons, [data-payment-total]').removeClass('loading');
  }
}

/**
 * Booking
 */
function create_pre_booking(callback = function(){}) {
  get_data({
    object: "create",
  }, function(data) {
    callback(data.booking_id);
  });
}

function log_transaction(payment = {}, callback) {
  get_data({
    object: "log_transaction",
    params: {
      gateway_id    : "Stripe",
      booking_id    : payment.booking_id,
      transaction_id: payment.id,
      payment_type  : payment.type,
      //payment_token : payment.transaction_token,
      amount        : payment.total
    }
  }, function(data) {
    if (data.invoice) {
      window.history.pushState(data, siteData.bookingUrls[type][data.step].title, siteData.bookingUrls[type][data.step].permalink);
      booking_load_step_data(data);
      if (callback)
        callback();
    }
  });
}

function remove_pre_booking(booking_id){
  get_data({
    object: 'failed',
    params : {
      booking_id: booking_id,
    }
  }, function(data) {
    //nothing to do at the time
  });
}
/*
 *
 * Payments section
 *
 */
let privacyCheckbox = document.getElementById('privacy-policy');
let paymentSelector = document.querySelectorAll('input[name="payment"]');

/**
 * Check Privacy policy checkbox state
 * @returns bool
 */
function isPrivacyEnabled() {
  if (!privacyCheckbox)
    return false;

  return privacyCheckbox.checked;
}

/**
 * Check if a Payment has been selected
 * @returns bool
 */
function isPaymentSelected() {
  let isChecked = false;

  if (paymentSelector.length == 0)
    isChecked = false;

  paymentSelector.forEach(function(radio) {
    if (radio.checked)
      isChecked = true;
  });

  return isChecked;
}

/**
 * Privacy Listener
 * @returns DOMEventListener
 */
function listenPrivacyCheckbox(handler) {
  if (!privacyCheckbox)
    return;

  return privacyCheckbox.addEventListener('change', handler);
}

/**
 * Payment Listener
 * @returns DOMEventListener
 */
function listenPaymentSelector(handler) {
  if (paymentSelector.length == 0)
    return;

  return $(paymentSelector).on('change', handler);
}
/**
 * Listen Privacy Policy checkbox to enable/disable Paypal Plus button
 * * * Express checkout validates inside object function
 * @returns void
 */
listenPrivacyCheckbox(function(event) {
  let checkbox = event.target;
  togglePaypalPlus((checkbox.checked && isPaymentSelected()));
});

/**
 * Listen Payment selector to enable/disable Paypal Plus button
 * @returns void
 */
listenPaymentSelector(function(event) {
  let radio = event.target;
  depositMessage(radio);
  togglePaypalPlus((radio.checked && isPrivacyEnabled()));
});

function depositMessage(input) {
  if(input.id == 'payment_deposit_input') {
    $('.payments-message[data-message="deposit"]').addClass('active');
  } else{
    $('.payments-message[data-message="deposit"]').removeClass('active');
  }
}

/**
 * Enable / Disable Paypal Plus button
 * @param boolean isChecked
 */
function togglePaypalPlus(isChecked) {
  if (!isChecked) {
    // Disable Paypal Plus button
    $('.payments-buttons').hide();
  } else {
    updateCart();
    $('.payments-buttons').show();
    /**
     * Stripe
     */
    // A reference to Stripe.js initialized with your real test publishable API key.
    var stripe = Stripe(siteData.ecommerce.stripe);
    // Disable the button until we have Stripe set up on the page
    document.querySelector("#submit").disabled = true;
    // Process payment
    fetch(siteData.ajaxEndpoint+'?action=booking_handler&object=stripePaymentIntent&intent='+Cart.transactions.purchase_units[0].amount.total)
    .then(function(result) {
      if (!result.ok) throw Error(result.status);
      return result.json();
    })
    .then(function(data) {      
      var elements = stripe.elements();
      var style = {
        base: {
          color: "#2a2a2a",
          fontFamily: 'Arial, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#666666"
          }
        },
        invalid: {
          fontFamily: 'Arial, sans-serif',
          color: "#c51745",
          iconColor: "#fa755a"
        }
      };
      var card = elements.create("card", { style: style });
      // Stripe injects an iframe into the DOM
      card.mount("#card-element");
      card.on("change", function (event) {
        // Disable the Pay button if there are no card details in the Element
        if (event.complete) {
          document.querySelector("#submit").disabled = false;
        } else if (event.error) {
          // show validation to customer
          document.querySelector("#submit").disabled = false;
        }
      });
      var form = document.getElementById("payment-form");
      form.addEventListener("submit", function(event) {
        event.preventDefault();
        // Complete payment when the submit button is clicked
        payWithCard(stripe, card, data.clientSecret);
      });
    }).catch(function(error) {
      $('.payments-buttons').hide();
    });
    // Calls stripe.confirmCardPayment
    // If the card requires authentication Stripe shows a pop-up modal to
    // prompt the user to enter authentication details without leaving your page.
    var payWithCard = function(stripe, card, clientSecret) {
      // Confirm checkfront reservation
      create_pre_booking(function(booking_id) {
        if (booking_id) {
          Cart.transactions.purchase_units[0].invoice_id = booking_id;
          // Process stripe payment
          loading(true);
          stripe
            .confirmCardPayment(clientSecret, {
              payment_method: {
                card: card
              }
            })
            .then(function(result) {
              if (result.error) {
                // Show error to your customer
                remove_pre_booking(booking_id)
                showError(result.error.message);
              } else {
                // The payment succeeded!
                log_transaction({
                  id               : result.paymentIntent.id,
                  booking_id       : booking_id
                });
              }
            });
        }
      });
    };

    // Show the customer the error from Stripe if their card fails to charge
    var showError = function(errorMsgText) {
      loading(false);
      var errorMsg = document.querySelector("#card-error");
      errorMsg.textContent = errorMsgText;
      setTimeout(function() {
        errorMsg.textContent = "";
      }, 6000);
    };

    // Show a spinner on payment submission
    var loading = function(isLoading) {
      if (isLoading) {
        // Disable the button and show a spinner
        document.querySelector("button").disabled = true;
        document.querySelector("#spinner").classList.remove("hidden");
        document.querySelector("#button-text").classList.add("hidden");
      } else {
        document.querySelector("button").disabled = false;
        document.querySelector("#spinner").classList.add("hidden");
        document.querySelector("#button-text").classList.remove("hidden");
      }
    };
  }
}
// Modal Functions
/**
 * Toggle Open/Close a Modal by ID
 * @param string modalName
 * @returns void
 */
function toggleModal(modalName = null) {
  let modal = document.getElementById(modalName);

  if (!modal)
    return;

  modal.classList.toggle('active');
  document.querySelector('body').classList.toggle('w-modal');
  if (modalName === "PayWithCard") {
    document.querySelector('body').classList.toggle('w-pay-modal');
  }
  return true;
}


// Close Modals
let toggleModals = document.querySelectorAll('[data-modal]');

/**
 * Change modal if exists an element with same ID as hash
 */
if (toggleModals.length > 0) {
  toggleModals.forEach(function (el) {
    el.addEventListener('click', function() {
      let modalName = el.getAttribute('data-modal');
      toggleModal(modalName);
    })
  });
}

/*
 * Make back/forward button to work
 */
window.onpopstate = function(event) {
  booking_load_step_data(event.state);
};

/*
 * Handles the process to show the requested step and its data
 */
function booking_load_step_data(data){
  if(!data){
    var data = {'step':1}
  }
  step = data.step;
  booking_show_step(data.step);
  switch (data.step) {
    case 2:
      booking_show_step2_data(data);
      break;
    case 3:
      booking_show_step3_data(data);
      break;
      case 4:
      booking_show_step4_data(data);
      break;
    default:
      break;
  }
}

/**
 * Loads the list of possible car variations to choose
 * @param {object} variations
 */
function showItemsVariations(variations){
  /*
  let mapCenter = googleMap.map.getCenter();
  let mapBounds = googleMap.map.getBounds();

  console.log(mapCenter, mapBounds);

  googleMap.map.fitBounds(mapBounds);
  */
  let variationLayout = document.querySelector(`[data-step="1"] [data-variation]`);
  let renderFrame = document.getElementById('mapRender');
  let has_discount = false;
  renderFrame.setAttribute('style', 'display:none !important');
  document.querySelector(`[data-step="1"] [data-items="variations"]`).innerHTML = "";
  variations.items[0].forEach(function(item, index){
    let elementObject = variationLayout.cloneNode(true);
    elementObject.querySelector(`[data-slip]`).setAttribute('data-slip',item.rate.slip);
    elementObject.querySelector(`[data-variation-title]`).innerHTML  = item.name;
    elementObject.querySelector(`[data-variation-price]`).innerHTML  = '$'+item.rate.sub_total+' USD';
    elementObject.querySelector(`[data-variation-description]`).innerHTML  = item.rate.summary.details;
    if(item.image[1].url_medium){
      elementObject.querySelector(`[data-variation-image]`).setAttribute('src',item.image[1].url_medium);
    }
    elementObject.querySelector(`[data-slip]`).disabled = false;
    document.querySelector(`[data-step="1"] [data-items="variations"]`).appendChild(elementObject);

    if(!has_discount) {
      if(item.discount.code != undefined) {
        has_discount = true;
      }
    }
  });

  $('#message-has-discount').hide();
  if(has_discount) {
    $('#message-has-discount').show().html(siteData.lang[13]);
  }
  if(!has_discount && (variations.data != undefined && variations.data.discount_code != 'ROUNDPVR')) {
    $('#message-has-discount').show().html(siteData.lang[14]);
  }
}
/*
 * Hide / show the step container
 */
function booking_show_step(step){
  $( '.grid-step' ).removeClass( 'active complete' );
  $( '.grid-content-step' ).removeClass( 'active' );
  for (let s = 1; s < step; s++) {
    $( 'div[ data-step='+ s +' ]' ).addClass( 'complete' );
  }
  $( 'div[ data-step='+ step +' ]' ).addClass( 'active' );
  $( '.main-section' ).attr( 'data-current', step );
}

function booking_update_totals (data) {
  var $cardElement = $('.summary_card');
  var $totalsElement = $('div[data-payment-total]');
  var discountedAmount = parseInt(data.data.cart.discount);

  if(discountedAmount != 0){
    let subtotalBase = booking_load_price(parseFloat(data.data.cart.total) + parseFloat(data.data.cart.discount));
    let subtotalDiscounted = booking_load_price(parseFloat(data.data.cart.total));
    // let countDiscounted = booking_load_price(parseFloat(data.data.cart.discount));
    let discountedDescription = siteData.lang[6];

    if(data.data.discount_code != 'ROUNDPVR') {
      discountedDescription = siteData.lang[12];
      $('.discount-text-validation').show();
    } 
    
    $cardElement.find('div[ data-price=regular ]').addClass('strike').html(subtotalBase);
    $cardElement.find('div[ data-price=discounted ]').show().html(subtotalDiscounted);
    $cardElement.find('div[ data-price=description ]').show().html(discountedDescription);
    $('.discount-message-below-total').show().html(discountedDescription);

    // $totalsElement.find('#price-subtotal').show().find('div[ data-price=subtotal]').html(subtotalBase);
    // $totalsElement.find('#price-discount').show().find('div[ data-price=discount]').html(countDiscounted);
    // $totalsElement.find('div[ data-price=regular]').html(subtotalDiscounted);
  }else{
    let subtotalBase = booking_load_price(parseFloat(data.data.cart.total));
    $cardElement.find('div[ data-price=regular ]').removeClass('strike').html(subtotalBase);
    $cardElement.find('div[ data-price=discounted ]').hide();
    $cardElement.find('div[ data-price=description ]').hide();

    // $totalsElement.find('#price-subtotal').hide();
    // $totalsElement.find('#price-discount').hide();
    // $totalsElement.find('div[ data-price=regular]').html(subtotalBase);

    $('.discount-text-validation').hide();
    $('.discount-message-below-total').hide();
  }
}

/*
 * Populates the step 2 container with data from the server
 */
function booking_show_step2_data(data){
  var $cardElement = $('.summary_card');

  booking_update_totals(data);

  var passengers;
  var summaryString = '';
  var cart = data.cart;
  updateCart({
    items  : Object.values(cart),
    total  : data.data.cart.total,
    deposit: data.data.cart.due,
    percent: data.data.cart.deposit.percent
  });
  var lastItem = Object.keys(cart)[Object.keys(cart).length-1];
  var itemDescription = false;
  if(type == 'private-tours'){
    if (data.cart[1].image && data.cart[1].image.url_medium) {
      $cardElement.find('[data-trip-image-url]').attr('src', data.cart[1].image.url_medium);
    }
    $cardElement.find('[data-trip-pickup-point]').html(data.form.destination);
    $cardElement.find('[data-trip-destination]').html(data.cart[1].name);
  }else{
    $cardElement.find('[data-trip-pickup-point]').html(data.data.origin.name);
    $cardElement.find('[data-trip-destination]').html(data.form.destination);
  }
  Object.keys(cart).forEach(function(item){
    if(!cart[item].optin){
      itemDescription = cart[item].summary;
      passengers = parseInt(cart[item].rate.qty);
      if(passengers > 1){
        var passenger_string = ' ' + siteData.lang[3];
      }else{
        var passenger_string = ' ' + siteData.lang[2];
      }
      let data_variation_string = '';
      if(type == 'private-tours'){
        summaryString += passengers + passenger_string + ' <strong>'+ cart[item].date.summary +'</strong>';
      }else{
        summaryString += passengers + passenger_string + ' <strong>'+ cart[item].date.summary +' @ '+ cart[item].date.start_time +'</strong> in ' + data.variations[cart[item].sku].name;

      }
      if(item < lastItem){
        summaryString += '<br>';
      }
    }
  });

  $cardElement.find('[data-trip-passengers]').html(summaryString);
  $cardElement.find('[data-trip-description]').html(itemDescription);
  //Phone mask
  var phoneInput = document.querySelector("#customer_phone");
  if(phoneInput){
    var instance = intlTelInput(phoneInput, {
      initialCountry: 'mx',
      preferredCountries: ['mx', 'ca', 'us'],
      utilsScript: utilsScript,
      separateDialCode: true
    });
  }
}

function booking_show_step3_data(data){
  var form = $('#bookingStep3');
  var type = $( '.main-section' ).attr( 'data-type' );
  var step = $( '.main-section' ).attr( 'data-current' );
  
  booking_update_totals(data);

  /*document.getElementById("apply-discount-code").addEventListener('click', (e) => {
    let input_code = document.querySelector('[data-discount-code]');
    if(input_code.value.trim('') != '') {
      let code = input_code.value;
      
      loadingCart(true);
      get_data({
        object : 'discount',
        params : {
          form: form.serialize(),
          type: type,
          step: parseInt(step),
          slip: parseInt(step),
          // way: 'arrival'
          discount_code: code
        }
      }, updateCart);
      loadingCart(false);
    }
  });*/

  booking_load_addon_cards(data);
  booking_load_tours_cards(data);
  //totals
  updateCart();
}

/**
 * Print invoice HTML in step 4
 * @param { invoice, step } data
 */
function booking_show_step4_data(data){
  if (data.invoice && data.step) {
    $('.grid-content-step[data-step='+data.step+']').html(data.invoice.html ? data.invoice.html : '');
  }
}

/**
 * Create gallery object
 */
function create_gallery_object(image_json = '[]', video = '{}') {
  let images = null;

if (image_json !== '[]' || video !== '{}' ) {
    images = JSON.parse(image_json);
    video = JSON.parse(video);

    images = Object.values(images); // Replace with array of values first
    // Return custom object array
    images = images.map(image => {
      return {
        src       : image.url,
        subHtml   : image.title,
        thumb     : image.url_small,
        responsive: `${image.url_medium} 479`
      }
    })

    if ( video.id && video.id !== '' ) {
      images = [
        {
          src: `https://youtube.com/watch?v=${video.id}&t=${video.start}`
        },
        ...images
      ]
    }
  }

  return images;
}

/*
 * Generates the HTML code that for the item selection
 */
function booking_load_map_items(data){
  var tempButtonText = $('#bookingStep1Submit').val();
  var parent = document.getElementById('items-list');
  let itemsData = data.items;
  // remove current cards
  let cards = parent.querySelectorAll('.card');
  cards.forEach(element => {
    parent.removeChild(element);
  });

  var htmlItemCardCode = '<div class="card min-padding"><div class="form-input-wrapper form-flex top-flex"><div class="card-image card-image-big active" %item_gallery%><img src="%item_image%" alt="%item_image_alt%" class="img-object-fit"></div><div class="card-description"><div class="label-margin">%item_name%</div><div class="rich-text w-richtext">%item_summary%</div></div><div class="card-prices active"><div class="price">%item_price%</div></div><div class="card-alt"><a href="#" data-slip="%item_slip%" class="card-label-button w-inline-block"><div>'+siteData.lang[9]+'</div></a></div></div></div>';
  var htmlItemCard;
  var price;
  var has_discount = false;
  itemsData[0].forEach(function(item){
    price = booking_load_price(item.rate.sub_total);
    htmlItemCard = htmlItemCardCode;
    htmlItemCard = htmlItemCard.replace(/%item_name%/g, item.name);
    htmlItemCard = htmlItemCard.replace(/%item_summary%/g, item.summary);
    if(item.image){
      htmlItemCard = htmlItemCard.replace(/%item_image%/g, item.image.url_medium);
      htmlItemCard = htmlItemCard.replace(/%item_image_alt%/g, item.image.title);
    }
    htmlItemCard = htmlItemCard.replace(/%item_slip%/g,item.rate.slip);
    htmlItemCard = htmlItemCard.replace(/%item_price%/g,price);

    if(item.image_json){
      var gallery_images = create_gallery_object(item.image_json, item.video);
    }

    if ( gallery_images ) {
      // Add data-attribute
      htmlItemCard = htmlItemCard.replace(/%item_gallery%/g, "data-open-gallery='"+JSON.stringify(gallery_images)+"'");
    } else {
      htmlItemCard = htmlItemCard.replace(/%item_gallery%/g, "");
    }

    if(!has_discount) {
      if(item.discount.code != undefined) {
        has_discount = true;
      }
    }

    parent.innerHTML += htmlItemCard;
  });

  $('.discount-text-tours').hide();
  if(has_discount) {
    $('.discount-text-tours').show().html(siteData.lang[13]);
  }
  if(!has_discount && (data.data != undefined && data.data.discount_code != 'ROUNDPVR')) {
    $('.discount-text-tours').show().html(siteData.lang[14]);
  }

  $('[data-open-gallery]').on('click', function() {
    let $this = $(this);
    let items = $this.data('open-gallery');

    $this.lightGallery({
      dynamic           : true,
      dynamicEl         : items,
      thumbnail         : true,
      download          : false,
      counter           : false
    });
  });

  $('[data-slip]').on('click', function(ev) {
    toggleModal('loader');
    let $parent = $(ev.target).parents('[data-slip]');
    let slip = $parent.data('slip');
    var type = $( '.main-section' ).attr( 'data-type' );
    var step = $( '.main-section' ).attr( 'data-current' );
    var nextStep = parseInt(step) + 1;
    var url  = siteData.bookingUrls[type][nextStep].permalink;
    var form = $('#bookingStep1');

    let children = form.find('[name^=children]').first();
    if (!children.val() || children.val() === "") {
      children.val(0);
    }

    get_data({
      object: 'slip',
      params: {
        slip: slip,
        form: form.serialize(),
        type: type,
        step: parseInt(step),
        way: 'arrival'
      }
    }, function(items) {
      toggleModal('loader');
      window.history.pushState(items, siteData.bookingUrls[type][nextStep].title, url);
      $('#bookingStep2').html(items.html.form);
      booking_load_step_data(items);
      $('#bookingStep1Submit').prop('disabled',false);
      $('#bookingStep1Submit').val( tempButtonText );
    });
  });
}

function booking_load_addon_cards(data){
  if(data.addons){
    $('#addonsWrapper').addClass('visible');
    var htmlCardCode = `
    <div class="card min-padding%has_tooltip%" data-addon="%card_sku%" data-line="%card_line_id%" data-item-qty="%card_item_qty%" data-item-price="%card_price_unit%">
      <div class="form-input-wrapper form-flex form-flex-top">
        <div class="card-flex-two-col">
          <div class="form-toggle-button toggle-button-full w-checkbox">
            <input type="checkbox" id="%card_sku%" name="%card_sku%" value="%card_line_id%" data-name="%card_sku%"
              class="w-checkbox-input" %card_status%>
            <label for="%card_sku%" class="form-toggle-slide w-form-label">%card_name%</label>
            <div class="form-toggle-text">
              <div class="form-toggle-label">%card_name%</div>%card_tooltip%
            </div>
          </div>
          <div class="card-alt">
            <div class="form-select-min-wrapper %card_status_class%">%card_options%</div>
          </div>
        </div>
        <div class="card-prices %card_status_class%">
          <div class="price">%card_price%</div>
        </div>
      </div>
    </div>`;
    var htmlCard = '';
    var htmlCards = '';
    var price;
    data.addons.forEach(function(item){
      if(item.options !== null){
        if(item.opt == 'in'){
          var addon_is_checked = 'checked="checked"';
          var addon_class_status = 'active';
        }else{
          var addon_is_checked = '';
          var addon_class_status = '';
        }
        price = booking_load_price(item.rate.total,true);
        htmlCard = htmlCardCode;
        htmlCard = htmlCard.replace(/%card_status%/g,addon_is_checked)
                           .replace(/%card_status_class%/g,addon_class_status)
                           .replace(/%card_sku%/g,item.sku)
                           .replace(/%card_name%/g,item.name)
                           .replace(/%card_price%/g,price)
                           .replace(/%card_line_id%/g,item.line_id)
                           .replace(/%card_options%/g,item.options.element)
                           .replace(/%has_tooltip%/g, item.options.tooltip !== '' ? ' w-tooltip' : '')
                           .replace(/%card_tooltip%/g,item.options.tooltip)
                           .replace(/%card_item_qty%/g,item.rate.qty)
                           .replace(/%card_price_unit%/g,item.rate.item_total);
        htmlCards += htmlCard;
      }
    });
    $('#addonCards').html(htmlCards);
    $('[data-addon]').on('change', 'input, select', function(ev) {
      // let id = $(this).parents('[data-addon]').data('addon');
      let $parent = $(ev.target).parents('[data-addon]');
      let line = $parent.data('line');
      let sku = $parent.data('addon');
      let value;
      let qty = $parent.data('item-qty');
      let unit_price = $parent.data('item-price');
      let item_total = parseFloat(qty) * parseFloat(unit_price);

      if (ev.target.type === 'checkbox') {
        value = (ev.target.checked ? "in" : "out");
        updateCart({
          item: {
            "sku" : sku,
            "rate": {
              "total"     : item_total,
              "item_total": unit_price,
              "qty"       : qty
            },
            "opt": value
          }
        }, true);
      get_data({
        object: 'addon',
        params: {
          line_id: line,
          param_name: ev.target.name,
          param_value: value
        }
        }, updateCart);
      } else {
        value = ev.target.value;
        qty = value;
      }

      item_total = parseFloat(qty) * parseFloat(unit_price);

      $parent.find('.price').html(booking_load_price(item_total, true));

      });

    $('[data-addon]').on('focusout', 'input, select', function(ev) {
      let $parent = $(ev.target).parents('[data-addon]');
      let line = $parent.data('line');
      let qty = $parent.data('item-qty');
      let sku = $parent.data('addon');

      let unit_price = $parent.data('item-price');

      if (ev.target.type !== 'checkbox') {
        let value = ev.target.value;
        if (parseInt(qty) !== parseInt(value)) {
          updateCart({
            item: {
              "sku" : sku,
              "rate": {
                "total"     : parseFloat(value) * parseFloat(unit_price),
                "item_total": unit_price,
                "qty"       : value
              },
              "opt": value
            }
          }, true);
          get_data({
            object: 'addon',
            params: {
              line_id: line,
              param_name: ev.target.name,
              param_value: value
            }
          }, updateCart);
          $parent.data('item-qty', value);
        }
      }
    });
  }else{
    $('#addonsWrapper').addClass('hide');
  }
}

function booking_load_tours_cards(){
  let $toursWrapper = $('#toursWrapper');
  if ( !$toursWrapper.hasClass('hide') ) {
    get_data({
      object: 'tours',
      params: {}
    }, function(data) {
      $('.loading-tours').hide();
      if(data.tours !== undefined){
        $('#toursWrapper').addClass('visible');
        var htmlCardCode = '<div class="card min-padding" data-tour="%card_sku%" data-line="%card_line_id%"><div class="form-input-wrapper form-flex top-flex"><div class="card-image %card_status_class%" %item_gallery%><img src="%card_image_url%" alt="" class="img-object-fit"></div><div class="card-flex-two-col"><div class="card-description"><div class="label-margin">%card_name%</div><div class="rich-text w-richtext">%item_summary%</div></div><div class="card-alt"><div class="form-select-min-wrapper %card_status_class%">%card_options%</div></div></div><div class="form-checkbox-button w-checkbox"><input type="checkbox" id="%card_sku%" name="%card_sku%" data-name="%card_sku%" class="w-checkbox-input" value="%card_slip%" %card_status%><label for="%card_sku%" class="form-checkbox-square w-form-label">%card_name%</label></div><div class="card-prices %card_status_class%"><div class="price">%card_price%</div></div></div></div>';
        var htmlCard = '';
        var htmlCards = '';
        var price;
        var items = data.tours.items[0];
        var item;
        if(item !== null){
          Object.keys(items).forEach(function(item_key){
            item = items[item_key];
            if(!item.line_id){
              item.line_id = '0';
            }
            if(item.in_cart){
              var item_is_checked = 'checked="checked"';
              var item_class_status = 'active';

              // Añadir al Cart global
              updateCart({ item: item, deposit: true });
            }else{
              var item_is_checked = '';
              var item_class_status = '';
            }
            price = booking_load_price(booking_get_item_total(item.rate),true);
            htmlCard = htmlCardCode;
            htmlCard = htmlCard.replace(/%card_status%/g,item_is_checked);
            htmlCard = htmlCard.replace(/%card_status_class%/g,item_class_status);
            htmlCard = htmlCard.replace(/%card_slip%/g,item.rate.slip);
            htmlCard = htmlCard.replace(/%card_sku%/g,item.sku);
            htmlCard = htmlCard.replace(/%card_name%/g,item.name);
            htmlCard = htmlCard.replace(/%item_summary%/g,item.summary);
            htmlCard = htmlCard.replace(/%card_price%/g,price);
            htmlCard = htmlCard.replace(/%card_line_id%/g,item.line_id);
            htmlCard = htmlCard.replace(/%card_image_url%/g,item.image.url_medium);
            htmlCard = htmlCard.replace(/%card_options%/g,item.options);

            var gallery_images = create_gallery_object(item.image_json, item.video);

            if ( gallery_images ) {
              // Add data-attribute
              htmlCard = htmlCard.replace(/%item_gallery%/g, "data-open-gallery='"+JSON.stringify(gallery_images)+"'");
            } else {
              htmlCard = htmlCard.replace(/%item_gallery%/g, "");
            }

            htmlCards += htmlCard;

          });
          let $tourCards = $('#toursCards').html(htmlCards);

          $('[data-open-gallery]').on('click', function() {
            let $this = $(this);
            let items = $this.data('open-gallery');

            $this.lightGallery({
              dynamic           : true,
              dynamicEl         : items,
              thumbnail         : true,
              download          : false,
              counter           : false
            });
          });

          $tourCards.find('[data-tour]').each((i, tourCard) => {
            let picker = $(tourCard).find('.picker');
            if(picker.length < 1){
              $('.datepicker').pickadate({
                format:'mmmm ddth, yyyy',
                formatSubmit: 'yyyy-mm-dd',
                hiddenPrefix: '_p_',
                hiddenSuffix: '_s_',
                min: true
                //min: [minDate.getFullYear(),minDate.getMonth(),minDate.getDate()]
              });
            }
          });

          $('[data-tour]').on('change', 'input, select', function(ev) {
            // let id = $(this).parents('[data-tour]').data('tour');

            let $parent = $(ev.target).parents('[data-tour]');
            let line = $parent.attr('data-line');
            let action = ev.target.type === 'checkbox' ? (ev.target.checked ? "in" : "out") : 'update';
            let value = '';
            if(ev.target.name == 'start_date'){
              value = $parent.find('input[name=_p_'+ev.target.name+'_s_]').val();
            }else{
              value = ev.target.value;
            }
            // Loading tour here
            loadingCart();
            if (action === 'update') {
              $parent.addClass('loading');
            } else if (action === 'out') {
              // Delete from global Cart
              Cart.items = Cart.items.filter(item => item.sku !== ev.target.name);
            }

            function getTourData() {
              get_data({
                object: 'cross',
                params: {
                  action: action,
                  line_id: line,
                  param_name: ev.target.name,
                  param_value: value
                }
              }, function(cart) {
                if(cart.item !== undefined){

                  if (action === 'update') {
                    // Update values
                    let itemInCart = Cart.items.findIndex(item => item.sku === cart.item.sku);
                    if (itemInCart >= 0) {
                      Cart.items[itemInCart] = { ...Cart.items[itemInCart], ...cart.item };
                      Cart.items[itemInCart].leftRequests++;
                    }
                    $parent.removeClass('loading');
                  }

                  updateCart(cart);
                  $parent.attr('data-line',cart.item.line_id || 0);
                  if (cart.item.rate) {
                    $parent.find('.price').html(booking_load_price(cart.item.rate.total, true));
                  }
                }else{
                  $parent.attr('data-line',0);
                }
              });
            }

            if (
                action !== "update" ||
                (action === "update" && parseInt(line) > 0)
              )
            {
              getTourData();
            } else {
              let checkForLine = setInterval(() => {
                line = $parent.attr('data-line');
                if (parseInt(line) > 0) {
                  getTourData();
                  clearInterval(checkForLine);
                }
              }, 500);
            }

          });
        }
      }else{
        $('#toursWrapper').addClass('hide');
      }
    });
  }
}

function booking_load_price(amount,addon = false){
  amount = parseFloat(amount).toFixed(2);
  var price = '$ '+ amount +' '+siteData.ecommerce.currency;
  if(addon){
    switch(addon){
      case 'entry':
        price = siteData.lang[5] + ' ' + price;
        break;
      default:
        price = '+ ' + price;
        break;
    }
  }
  return price;
}

function booking_get_item_total(rate){
  var amount;
  if(rate.total !== undefined){
    return rate.total;
  }
  if(rate.sub_total !== undefined){
    return rate.sub_total;
  }
}

  /*
   * Toggle functionality for item addons
   */
  $(document).on('click', '.toggle-button-full input[type="checkbox"]' , function() {
    if($(this).is(':checked')){
      toogle_addon_on($(this));
    }else{
      toogle_addon_off($(this));
    }
  });
  function toogle_addon_on(element){
    element.parent().parent().siblings('.card-prices').addClass('active');
    element.parent().siblings('.card-alt').children('.form-select-min-wrapper').addClass('active');
  }
  function toogle_addon_off(element){
    element.parent().parent().siblings('.card-prices').removeClass('active');
    element.parent().siblings('.card-alt').children('.form-select-min-wrapper').removeClass('active');
  }

  /*
   * Toggle functionality for item cross-selling
   */
  $(document).on('click', '.form-checkbox-button input[type="checkbox"]' , function() {
    if($(this).is(':checked')){
      $(this).parents('.form-input-wrapper').children('.card-prices, .card-image').addClass('active');
      $(this).parents('.form-input-wrapper').children('.card-flex-two-col').children('.card-alt').children('.form-select-min-wrapper').addClass('active');
    }else{
      $(this).parents('.form-input-wrapper').children('.card-prices, .card-image').removeClass('active');
      $(this).parents('.form-input-wrapper').children('.card-flex-two-col').children('.card-alt').children('.form-select-min-wrapper').removeClass('active');
    }
  });

  //checkbox round trip
  var round_trip = $('#round-trip');
  round_trip.on('click', function(){
    if($(this).is(':checked')){
      $('.form-toggle-button').addClass('opened');
      $('#departure-wrapper').addClass('active');
      $('[data-conditional="round-trip"]').removeAttr('disabled');
      $('[data-conditional="round-trip"]').siblings().removeAttr('disabled');
    }else{
      $('[data-conditional="round-trip"]').attr('disabled','disabled');
      $('[data-conditional="round-trip"]').siblings().attr('disabled','disabled');
      $('#departure-wrapper').removeClass('active');
    }
  });
  /*
  $('.grid-step').on('click', '.step-heading', function(event) {
    let stepElement = event.delegateTarget;
    console.log(stepElement);
    if (stepElement) {
      let stepTarget = stepElement.getAttribute('data-step');
      if (step > stepTarget) {
        window.history.pushState({step: stepTarget}, siteData.bookingUrls[type][stepTarget].title, siteData.bookingUrls[type][stepTarget].permalink);
        step = stepTarget;
        booking_show_step(step);
      }
    }
  });
  */

function toggleSubmitText(selector){
  let element = document.querySelector(selector);
  let defaultLabel = element.getAttribute('data-label-default');
  let loadingLabel = element.getAttribute('data-label-loading');
  let buttonText = element.value;
  element.disabled = !element.disabled;
  element.value = (defaultLabel == buttonText) ? loadingLabel : defaultLabel;
}